import React from 'react'
import '../assets/css/rodape-hash.css'

// Hash de validação no rodapé de cada folha impressa: o tfoot se repete em todas as folhas reservando
// o espaço, e o rodapé fixo (também repetido na impressão) ocupa esse espaço sem cobrir o conteúdo
const ReservaRodapeHash = ({ hash, children }) => hash
    ? <table className='reserva-rodape-hash'>
        <tfoot><tr><td><div className='espaco-rodape-hash' /></td></tr></tfoot>
        <tbody><tr><td>{children}</td></tr></tbody>
    </table>
    : <>{children}</>

const RodapeHash = ({ hash }) => hash ? <div className='rodape-hash'>HASH: {hash}</div> : <></>

export { ReservaRodapeHash, RodapeHash }
